module.exports = __webpack_public_path__ + "static/media/cropped-me.35cd06dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/cropped-me.png
// module id = 40
// module chunks = 0